import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiBills } from 'modules/api';
import { PagingParams } from '../../types/PagingParams';

export const fetchBills = createAsyncThunk(
  'auth/getBills',
  async (params: PagingParams, { rejectWithValue }) => {
    try {
      const response = await ApiBills.getBills(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const filterBills = createAsyncThunk(
  'auth/getBills',
  async (params: PagingParams, { rejectWithValue }) => {
    try {
      const response = await ApiBills.filterBills(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchContractNumberCheckboxesValues = createAsyncThunk(
  'bill/contractNumber',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiBills.fetchNumberList();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchStatusCheckboxesValues = createAsyncThunk(
  'bill/status',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiBills.fetchStatusList();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
